import { Spinner } from '../ui/index.js'

export function LoadingState({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="state-block">
      <Spinner size="medium" />
      <span style={{ fontSize: 13 }}>{label}</span>
    </div>
  )
}
